module.exports = {
	"de": {
		"help-tool": {
			"button-text": "Hilfe",
			"support-button": "Support erhalten",
			"support-page": {
				"create-ticket": {
					"title": "Support erhalten",
					"instructions": "Reichen Sie unten eine Anfrage ein und wir melden uns innerhalb eines Werktags bei Ihnen.",
					"related-content": {
						"title": "Dies könnte Ihnen bei der Problemlösung helfen"
					},
					"fields": {
						"mid": {
							"label": "Shop wählen",
							"validation": "Shop ist erforderlich"
						},
						"phoneNumber": {
							"label": "Telefonnummer (optional)"
						},
						"topic": {
							"question": "Um was geht es bei Ihrer Frage?",
							"label": "Wählen Sie ein Thema aus",
							"validation": "Thema ist erforderlich",
							"options": {
								"orders": "Bestellungen",
								"settlements": "Abrechnungen",
								"agreements": "Vereinbarungen",
								"others": "Anderes"
							}
						},
						"subject": {
							"label": "Betreff",
							"validation": "Betreff ist erforderlich"
						},
						"description": {
							"label": "Nachricht",
							"validation": "Beschreibung ist erforderlich"
						},
						"attachment": {
							"label": "Anlagen hinzufügen",
							"button": "Hochladen",
							"info": "Das Hinzufügen von Screenshots hilft, das Problem schneller zu lösen.",
							"supportedFileTypes": "Unterstützte Dateiformate: .png, .jpg, .pdf",
							"error": "Die Gesamtgröße der Dateien darf nicht über {maxSize} MB liegen."
						}
					},
					"submit": "Antrag senden",
					"service-unavailable-error": "Ups! Ein Fehler ist aufgetreten. Bitte versuchen Sie es in ein paar Minuten erneut oder kontaktieren Sie {link}, sollte das Problem weiterhin bestehen.",
					"generic-error": "Wir konnten Ihre Anfrage nicht verarbeiten. Die Kommunikation unserer Systeme wurde unterbrochen. Bitte laden Sie die Seite neu oder versuchen Sie es später noch einmal. Sollte das Problem fortbestehen, kontaktieren Sie bitte {link}.",
					"contact-link": "Kontaktieren Sie uns"
				},
				"view-ticket": {
					"title": "Fertig!",
					"details": "Wir haben Ihre Anfrage erhalten und werden uns innerhalb eines Werktags bei Ihnen melden. Dies sind Ihre Angaben:",
					"ticket": "Anfrage Nr. {ticketId}",
					"email": "E-Mail: {email}",
					"status": "Sie können den Status in unserer Support-Seite einsehen",
					"track": "Status einsehen"
				}
			},
			"header": {
				"homeLink": "Zurücksetzen"
			},
			"home": {
				"greeting": "Hallo, {givenName}! Wie können wir Ihnen helfen?",
				"topics": "Wobei benötigen Sie Hilfe?"
			},
			"topics": {
				"expandButton": "Mehr"
			},
			"feedback": {
				"title": "Hat Ihnen das weitergeholfen?",
				"optionYes": "Ja, das hat mir weitergeholfen",
				"optionNo": "Nein, ich benötige noch Hilfe",
				"positiveFeedback": "Vielen Dank für das positive Feedback, das macht es für uns viel einfacher, Ihnen in Zukunft relevantere Artikel bieten zu können."
			},
			"freeTextFeedback": {
				"title": "Helfen Sie uns, besser zu werden",
				"placeholder": "Warum fanden Sie diesen Inhalt nicht nützlich?",
				"submitButton": "Senden",
				"feedbackMessage": "Vielen Dank für Ihr Feedback, das macht es für uns viel einfacher, Ihnen in Zukunft relevantere Artikel bieten zu können."
			},
			"relatedContent": {
				"title": "Relevante Inhalte"
			},
			"search": {
				"buttonLabel": "Suchen",
				"input": "Suche nach Artikeln ...",
				"loading": "Lädt …",
				"results": {
					"contact": "Sie finden nicht die benötigte Hilfe?",
					"empty": "Leider wurden keine Ergebnisse für Ihre Anfrage gefunden. Versuchen Sie, nach einem anderen Begriff zu suchen.",
					"singleTopicFound": "Wir haben 1 Thema gefunden",
					"multipleTopicsFound": "Wir haben {count} Themen gefunden",
					"singleArticleFound": "Wir haben 1 Artikel gefunden",
					"multipleArticlesFound": "Wir haben {count} Artikel gefunden"
				}
			},
			"contact": {
				"title": "Kontakt",
				"channelsIntro": "Wenden Sie sich an uns, sodass wir Ihnen behilflich sein können.",
				"businessDetailsTitle": "Ihre Geschäftsdaten",
				"businessDetailsName": "Name des Geschäfts",
				"businessDetailsEmail": "E-Mail",
				"businessDetailsMid": "Händler ID",
				"phone": {
					"title": "Rufen Sie uns an",
					"paragraph": "Sie können uns werktags während der Geschäftszeiten anrufen. Wenn Sie in Schweden oder im Vereinigten Königreich wohnen, können Sie uns auch am Wochenende zwischen 10:00 und 16:00 Uhr anrufen."
				},
				"email": {
					"title": "Schreiben Sie uns eine E-Mail",
					"paragraph": "Schreiben Sie uns eine E-Mail. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen."
				}
			},
			"errorBoundary": {
				"title": "Etwas ist schief gelaufen",
				"message": "Leider ist ein Fehler aufgetreten. Klicken Sie entweder auf \"Zurück\", um zum Hilfe-Tool zurückzukehren oder auf \"Support erhalten\", um uns zu kontaktieren.",
				"resetButton": "Zurück",
				"errorId": "Fehler-ID: {errorId}"
			},
			"tour": {
				"prev": "Zurück",
				"next": "Weiter",
				"done": "Fertig"
			},
			"notAvailableMobile": {
				"title": "Nicht verfügbar",
				"buttonBack": "Zurück",
				"paragraph": "Dieser Inhalt ist auf Ihrem Gerät nicht verfügbar. Versuchen Sie, ihn auf einem Gerät mit höherer Bildschirmauflösung zu starten, etwa auf einem Desktop-Computer."
			},
			"shareButton": {
				"title": {
					"article": "Einen Deep-Link zu diesem Artikel teilen",
					"topic": "Einen Deep-Link zu diesem Thema teilen",
					"tour": "Einen Deep-Link zu dieser Tour teilen"
				},
				"radioItemHome": "Start App",
				"descriptionHome": "Öffnet den Hilfe-Artikel auf der Startseite im Händlerportal",
				"radioItemCurrent": "Aktuelle Seite",
				"descriptionCurrent": "Öffnet den Hilfe-Artikel auf der aktuellen Seite"
			},
			"marketSelector": {
				"whichMarketToContact": "Welchen Markt möchten Sie gerne kontaktieren?"
			}
		},
		"orientation": {
			"title": "Lernen Sie ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hallo {name}! 👋 Ich bin Ihr Klarna Assistent.",
				"whatDoYouNeedHelpWithPart2": "In vielen Fällen kann ich Ihnen helfen, Ihre Frage in weniger als 5 Minuten zu klären.",
				"whatDoYouNeedHelpWithPart3": "Womit kann ich Ihnen heute helfen?",
				"selectSupportChannel": "Bitte wählen Sie einen Kanal, um unseren Support-Service zu kontaktieren.",
				"selectPayoutIssue": "Perfekt! Fahren Sie fort und wählen Sie ein Problem mit Auszahlungen 👇",
				"selectOrderIssue": "Perfekt! Fahren Sie fort und wählen Sie ein Problem mit Bestellungen 👇",
				"capturedOrders": "Haben Sie {link1} Bestellungen?",
				"capturedOrdersLink1": "erfasste",
				"notPaidOrder": {
					"isScheduleFollowed": "Wird Ihr {link1} (einschließlich Auszahlungsverzögerung) eingehalten?",
					"isScheduleFollowedLink1": "Auszahlungs-Zeitplan",
					"isHoldbackOrDebt": "Wurde Ihre Auszahlungsverzögerung überschritten, prüfen Sie bitte Ihre {link1}. Gibt es einbehaltene oder geschuldete Beträge aufgrund von Retouren/Rückbelastungen?",
					"isHoldbackOrDebtLink1": "letzte Abrechnung"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Bitte sehen Sie nach, wann Sie die Bestellungen erfasst haben, für die Sie eine Auszahlung erwarten und berücksichtigen Sie dabei auch Ihre Auszahlungsverzögerung. Sie finden Ihre Bestellungen {link1}. Wurden die Bestellungen erfasst, für die Sie eine Auszahlung erwarten?",
					"isScheduleFollowedLink1": "EU-Richtlinie"
				},
				"changePaymentFrequency": "Haben Sie mehr als 30 erfasste Bestellungen pro Monat innerhalb eines Quartals erhalten?",
				"whenWillGetPaid": "Das Auszahlungsdatum richtet sich nach Ihrem Zahlungsplan und der in Ihrem Vertrag (AGB) angegebenen Zahlungsverzögerung. Wenn Sie sich über Ihre Auszahlungs-Einstellungen unsicher sind, können Sie diese unter {link1} einsehen. Wird Ihr Auszahlungs-Zeitplan (inkl. Auszahlungsverzögerung) eingehalten?",
				"whenWillGetPaidLink1": "Abrechnungen",
				"thatHelped": "Vielen Dank für das positive Feedback, das macht es für uns viel einfacher, Ihnen in Zukunft eine individuellere Hilfe bieten zu können. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ich verstehe! Haben Sie noch nicht erfasste Bestellungen?",
					"haveUncapturedOrdersPart2": "Wenn Sie nicht wissen, wo Sie nachsehen können, gehen Sie bitte zu {link1}.",
					"haveUncapturedOrdersPart2Link1": "diese Seite,",
					"expirationDateSurpassed": "Ist das Ablaufdatum überschritten? (In der Regel 28 Tage)",
					"customerCreditPaymentMethod": "Hat die Kundschaft eine Kredit-Zahlungsmethode gewählt (Rechnung, Konto, Lastschrift)?",
					"isOrderCaptured": "Ist die Bestellung {link1}?",
					"isOrderCapturedLink1": "erfasst"
				}
			},
			"options": {
				"payout": "Auszahlungen",
				"orders": "Bestellungen",
				"otherIssue": "Andere Probleme",
				"whenPaidOrderNext": "Wann ist mein nächstes Auszahlungsdatum?",
				"notPaidOrder": "Meine Auszahlung steht aus",
				"paidWrongAmount": "Der Auszahlungsbetrag ist nicht korrekt",
				"changeHowOftenPaid": "Ich möchte das Auszahlungsintervall ändern",
				"dontKnowHowToCaptureOrder": "Ich weiß nicht, wie eine Bestellung erfasst wird",
				"missedCaptureDeadline": "Ich habe die Frist zur Erfassung versäumt",
				"needToRefundAnOrder": "Ich muss eine Bestellung rückerstatten",
				"yes": "Ja",
				"no": "Nein",
				"partially": "Teilweise",
				"iNeedMoreHelp": "Ich benötige weitere Hilfe",
				"thatHelped": "Das hat geholfen",
				"contactSupportChannel": "Support-Kanäle kontaktieren"
			},
			"explanations": {
				"noCapturedOrders": "Als ersten Schritt müssen Sie {link1}. Sobald Sie die Bestellung erfasst haben, überweisen wir den Betrag auf Ihr Bankkonto. Gebühren, Retouren und andere Kosten werden von diesem Betrag abgezogen.",
				"noCapturedOrdersLink1": "eine Bestellung erfassen",
				"feesReturnsHoldbacks": "Gebühren, Retouren und andere Kosten werden vom Auszahlungsbetrag abgezogen. Bitte sehen Sie nach, ob die {link1} einbehaltene oder geschuldete Beträge aufgrund von Retouren/Rückbelastungen enthält.",
				"feesReturnsHoldbacksLink1": "letzte Abrechnung",
				"notPaidOrder": {
					"scheduleFollowed": "Sobald Sie die Bestellung erfasst haben, überweisen wir den Betrag nach Ihrem Auszahlungs-Zeitplan auf Ihr Bankkonto. Gebühren, Retouren und andere Kosten werden von diesem Betrag abgezogen. Bitte sehen Sie nach, welchen Betrag Ihre {link1} ausweist.",
					"scheduleFollowedLink1": "letzte Abrechnung",
					"noHoldback": "Bitte prüfen Sie, ob Sie für die Währung der Auszahlung {link1} die richtige Bankverbindung angegeben haben.",
					"noHoldbackLink1": "EU-Richtlinie",
					"withHoldback": "Falls der Gesamtbetrag der erfassten Bestellungen geschuldete Beträge übersteigt, prüfen Sie bitte, ob Sie für die Währung der Auszahlung {link1} die richtige Bankverbindung angegeben haben.",
					"withHoldbackLink1": "EU-Richtlinie"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Sie erhalten Ihre nächste Auszahlung gemäß Ihrem Auszahlungs-Zeitplan und der Auszahlungsverzögerung."
				},
				"changePaymentFrequency": {
					"isAble": "Bitte kontaktieren Sie unseren Support über einen der unten angegebenen Kanäle.",
					"isUnable": "Leider erfüllen Sie nicht die Voraussetzungen, Ihren Auszahlungs-Zeitplan zu ändern."
				},
				"orders": {
					"uncapturedDynamicYes": "Ah, ich sehe, dass Sie {number} noch nicht erfasste Bestellungen haben.",
					"uncapturedDynamicNo": "Ich sehe, dass Sie keine noch nicht erfassten Bestellungen haben",
					"uncapturedYesPart1": "Dann ist es also an der Zeit, Bestellungen zu erfassen! So gehen Sie vor:",
					"uncapturedYesPart2": "1. Gehen Sie zur Seite Bestellungen, {link1}",
					"uncapturesYesPart2Link1": "indem Sie hier klicken",
					"uncapturedYesPart3": "2. Klicken Sie auf die Klarna Referenznummer der Bestellung, die Sie erfassen möchten",
					"uncapturedYesPart4": "3. Wählen Sie die Artikel aus und fügen Sie den Betrag hinzu, den Sie erfassen möchten",
					"uncapturedYesPart5": "4. Klicken Sie auf „Erfassen“",
					"uncapturedNoPart1": "Um eine Bestellung zu erfassen, müssen zunächst Bestellungen zum Erfassen vorliegen.",
					"uncapturedNoPart2": "Wenn Sie eine Bestellung erfassen, bestätigen Sie, dass die Bestellung an die Kundschaft versendet wurde. Dies sollte bei jeder Bestellung stets am selben Tag erfolgen, an dem sie versendet wurde. Eine Bestellung zu erfassen ist zugleich das Signal an uns, eine Ihre Auszahlung für die Bestellung auszulösen. Lesen Sie weiter, wie Sie eine Bestellung erfassen {link1}.",
					"uncapturedNoLink1": "hier",
					"customerCreditPaymentMethodNo": "Leider können wir eine bereits abgelaufene Bestellung nicht verlängern. In einem solchen Fall müssen Sie die Bestellung erneut anlegen.",
					"expirationDateSurpassedYes": "Gerne helfen wir Ihnen bei der Verlängerung der Bestellung. Bitte kontaktieren Sie unseren Support über einen der unten angegebenen Kanäle.",
					"expirationDateSurpassedNo": "Gehen Sie zu {link1}. Wählen Sie die Bestellung aus, indem Sie das Kästchen neben der Klarna Referenznummer markieren. Klicken Sie auf Ablaufdatum verlängern und bestätigen Sie Ihre Anfrage.",
					"expirationDateSurpassedNoLink1": "Bestellungen > Zu Erfassen",
					"isOrderCapturedYesPart1": "Wählen Sie die Artikel aus, die Sie erstatten möchten, und klicken Sie auf Rückerstattung. Sie können auch zuerst auf Rückerstattung klicken und den Betrag, den Sie erstatten möchten, eingeben. Sie entscheiden, was für Sie am besten funktioniert.",
					"isOrderCapturedYesPart2": "Ihre Kundschaft erhält innerhalb von 2 bis 5 Werktagen eine Rückzahlung des bereits gezahlten Betrags. Und Sie werden feststellen, dass dieser Betrag von Ihrer nächsten Auszahlung abgezogen wurde.",
					"isOrderCapturedNo": "Wenn eine nicht erfasste Bestellung nicht versendet wird, können Sie die gesamte Bestellung {link1}. Gehen Sie dazu zur {link2} und klicken Sie auf Bestellung stornieren.",
					"isOrderCapturedNoLink1": "stornieren",
					"isOrderCapturedNoLink2": "Seite Bestellungen",
					"refundPartiallyCaptured": "Wenn Sie die Bestellung für bereits versandte Artikel teilweise erfasst haben, aber den Rest nicht ausführen werden, sollten Sie den nicht erfassten Teil der Bestellung freigeben. Gehen Sie zur {link1}, klicken Sie auf Weitere Aktionen und wählen Sie dann Freigabe.",
					"refundPartiallyCapturedLink1": "Seite Bestellungen"
				}
			},
			"messages": {
				"sorryToHearThat": "Tut mir leid, dass ich Ihnen nicht weiterhelfen konnte. Sie werden in Kürze an unseren Support weitergeleitet."
			},
			"button": {
				"label": "Support erhalten"
			},
			"contact": {
				"chat": "Mit einem/r Mitarbeitenden chatten",
				"ticket": "Ein Ticket einreichen",
				"times": {
					"minutes": "Wartezeit: {time} Minute(n)",
					"hours": "Wartezeit: {time} Stunde(n)",
					"days": "Wartezeit: {time} Tag(e)"
				}
			}
		}
	}
};